module.exports = __webpack_public_path__ + "media/images/forbes-99299484fb0e5db6f8a55084eb8bdf8d.svg";